// removed by extract-text-webpack-plugin
module.exports = {"modalOpen":"tvLaB","modalOverlay":"_2azRm","modal":"_3-UyW","modalHeader":"uhkMz","modalHeaderTitle":"_3ahrm","modalHeaderBackButton":"m2eDL","modalFooter":"_1ARrC","modalFooterLeftButton":"_2Fgyv","modalFooterRightButton":"_1mgyy","rightSidebarModal":"V7iL-","slideInFromRight":"_2KwRC","rightSidebarModalClosing":"_2z87H","slideOutToRight":"Hq0rY"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Modal/index.sass
// module id = 169
// module chunks = 0 1